import { formBuilderPath, formsListPath, formSubmissionsPath } from './routes';

// How each Forms page answers the product tour's screen requests
// (help/FormsHelp `navigate`). A page ignores what it can't act on; the
// tour then skips the steps whose targets never show.

// The form the tour walks through: the first one with entries, so the
// Submissions, Entry card and Exports chapters have something to show; else
// the first form.
export const pickTourForm = (forms) => {
  const list = forms || [];
  return list.find((form) => form.submission_count > 0) || list[0] || null;
};

// Forms list. 'list' leaves the Archived view (the tour needs active
// cards); 'builder' and 'submissions' open pickTourForm's form.
export const listTourNavigate =
  ({ forms, archived, account, routePrefix, push, closeOverlays }) =>
  (where) => {
    if (where === 'close-overlays') {
      closeOverlays();
      return;
    }
    if (where === 'list') {
      if (archived) push(formsListPath(routePrefix, { account }));
      return;
    }
    const form = pickTourForm(forms);
    if (!form) return;
    if (where === 'builder') push(formBuilderPath(routePrefix, form.id));
    else if (where === 'submissions') {
      push(formSubmissionsPath(routePrefix, form.id));
    }
  };

// Builder. It never leaves unsaved edits behind: with changes pending,
// 'list' and 'submissions' stay put. `layout` is useBuilderLayout's mode:
// wide shows settings in the right column, narrow in drawers, mobile in
// full-screen panes.
export const builderTourNavigate =
  ({
    formId,
    fieldId,
    dirty,
    layout,
    routePrefix,
    leaveTo,
    dispatch,
    setDrawer,
    closeOverlays,
  }) =>
  (where) => {
    switch (where) {
      case 'list':
        if (!dirty) leaveTo(formsListPath(routePrefix));
        return;
      case 'submissions':
        if (!dirty) leaveTo(formSubmissionsPath(routePrefix, formId));
        return;
      case 'close-overlays':
        closeOverlays();
        return;
      case 'select-field':
        if (!fieldId) return;
        if (layout === 'mobile') {
          dispatch({ type: 'SELECT', id: fieldId, pane: 'edit' });
          return;
        }
        dispatch({ type: 'SELECT', id: fieldId });
        if (layout === 'narrow') setDrawer('field');
        return;
      case 'form-settings':
        if (layout === 'mobile')
          dispatch({ type: 'SET_PANE', pane: 'settings' });
        else if (layout === 'narrow') setDrawer('settings');
        else dispatch({ type: 'SELECT', id: null });
        break;
      default:
    }
  };

// Submissions. 'entry' opens the first row's card and 'export' the Export
// dialog; before the first page of rows has loaded, `later(what)` asks the
// page to do it once they arrive. 'submissions' is already here.
export const submissionsTourNavigate =
  ({
    formId,
    rows,
    ready,
    canExport,
    routePrefix,
    push,
    openEntry,
    openExport,
    closeOverlays,
    later,
  }) =>
  (where) => {
    switch (where) {
      case 'list':
        push(formsListPath(routePrefix));
        return;
      case 'builder':
        push(formBuilderPath(routePrefix, formId));
        return;
      case 'entry':
        if (rows.length) openEntry(rows[0]);
        else if (!ready) later('entry');
        return;
      case 'export':
        if (canExport) openExport();
        else if (!ready) later('export');
        return;
      case 'close-overlays':
        closeOverlays();
        break;
      default:
    }
  };
